<template>
  <div class="preheat">
    <div class="preheatimg">
      <img
        src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/preheat.png"
        alt=""
      />
      <img
        src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/preheat1.png"
        alt=""
      />
      <img
        src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/preheat2.png"
        alt=""
      />
      <img
        src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/preheat3.png"
        alt=""
      />
      <img
        src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/preheat4.png"
        alt=""
      />
      <img
        src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/preheat5.png"
        alt=""
      />
      <img
        src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/preheat6.png"
        alt=""
      />
      <img
        src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/preheat7.png"
        alt=""
      />
    </div>
    <div class="preheatbottom">
      <div class="closebtn"></div>
      <div class="logodetails">
        <img
          src="https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/logo.png"
          alt=""
        />
        <div class="details">
          <div>音乐窝</div>
          <div>下载音乐窝APP，关注大赛最新动态</div>
        </div>
      </div>
      <div class="loading" @click="downLoad">下载</div>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
export default {
  name: "preheat",
  data() {
    return {};
  },
  computed: {},
  components: {},
  methods: {
    downLoad() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //安卓端
      var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
      if (isIos) {
        // console.log('ios')
        var loadDateTime = new Date();
        window.setTimeout(function () {
          var timeOutDateTime = new Date();
          if (timeOutDateTime - loadDateTime < 5000) {
            window.location = "itms-apps://itunes.apple.com/app/id1238121127";
          } else {
            window.close();
          }
        }, 25);
        window.location = "liveconwaysmusiccom://";
      } else {
        // console.log('az')
        window.location = "scheme://musicwow.com";
        setTimeout(function () {
          window.location =
            "https://sj.qq.com/myapp/detail.htm?apkName=com.conwaysmusic.live";
        }, 300);
      }
    },
    getshare() {
      wx.ready(function () {
        wx.updateTimelineShareData({
          title: "“职协杯”2020全国鼓手大赛", // 分享标题
          link: "https://mobile.musicwow.com/#/preheat", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/prelogo.png", // 分享图标
          success: function () {
            // console.log('设置成功')
          },
        });
        wx.updateAppMessageShareData({
          title: "“职协杯”2020全国鼓手大赛", // 分享标题
          desc: "大赛报名通道将于7月18日0时正式开启，下载音乐窝app关注最新状态！", // 分享描述
          link: "https://mobile.musicwow.com/#/preheat", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "https://wowsite.oss-cn-shenzhen.aliyuncs.com/public/uploads/preheat/prelogo.png", // 分享图标
          success: function () {
            // console.log('设置成功')
          },
        });
      });
    },
    async getconfig() {
      var url = window.location.href;
      await this.$API.getwxconfig({ url: url }).then((res) => {
        var config = res.data.config;
        wx.config({
          debug: true,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: [
            "updateTimelineShareData", //分享给好友
            "updateAppMessageShareData", //分享到朋友圈
          ],
        });
      });
      await this.getshare();
    },
  },
  mounted() {
    this.getconfig();
  },
  created() {},
  beforecreate() {},
};
</script>
<style lang="scss" scoped>
.preheat {
  padding-bottom: 82px;
}
.preheatimg img {
  display: block;
}
.preheatbottom {
  width: 98%;
  padding: 5px 1% 5px 1%;
  background: #ffffff;
  display: flex;
  align-items: center;
  height: 72px;
  position: fixed;
  bottom: 0;
}
.closebtn {
  width: 8%;
}
.logodetails {
  width: 72%;
  display: flex;
  align-items: center;
}
.logodetails img {
  width: 54px;
  height: 54px;
  margin-right: 10px;
}
.details {
  text-align: left;
}
.details div:nth-of-type(1) {
  font-size: 16px;
  color: #333338;
  margin-bottom: 5px;
}
.details div:nth-of-type(2) {
  font-size: 12px;
  color: #979797;
}
.loading {
  color: #07d1aa;
  font-size: 12px;
  width: 20%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

